const GET_USER = "GET_USER"
const GET_USER_SUCCESS = "GET_USER_SUCCESS"
const GET_USER_FAIL = "GET_USER_FAIL"


const BASE_ENDPOINT = '/Account/GetUserInfo';
const initialValues = {

  loading: false,
  isAuth:false,
  authenticatedUser : { }
};

const authentication = (state = initialValues, action) => {

    switch (action.type) {
  

  
      case GET_USER:{
  
        return{
           ...state,
           loading:true,
  
        }
  
      }
  
  
      case GET_USER_SUCCESS:{
  
        return{
           ...state,
             loading:false,
            authenticatedUser: action.payload.data,
            isAuth: true,
        }
  
      }
    
      case GET_USER_FAIL: {
        return {
          ...state,
          loading: false,
          hasError: true,
        };
      }
  
      default: {
        return state;
      }
  
    }
  };

export const getUserLogged = () => {
    return {
      type: GET_USER,
      payload: {
        request: {
          url: BASE_ENDPOINT,
          method:'GET'  
        }
      }    
    }
};


export default authentication;